/*
 * @Date: 2020-08-11 19:24:21
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-08-12 20:57:12
 * @FilePath: \pc-mall\src\plugins\element.js
 */
import Vue from 'vue'
import {
  Button,
  DatePicker,
  Table,
  TableColumn,
  Input,
  RadioGroup,
  Radio,
  RadioButton,
  Form,
  FormItem,
  InputNumber,
  Select,
  Option,
  Dialog,
  Message,
  MessageBox,
  Carousel,
  CarouselItem,
  Pagination,
  Loading,
  Checkbox,
  Row,
  Col,
  Tabs,
  TabPane,
  Alert,
  Menu,
  MenuItem
} from 'element-ui'
Vue.use(MenuItem)
Vue.use(Menu)
Vue.use(Alert)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Col)
Vue.use(Row)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Loading)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(InputNumber)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Pagination)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
